module.exports = __webpack_public_path__ + "media/ubud/rice_paddy-c613db23.jpg";